// Function to convert bigint to number
import { ethers } from 'ethers';

export const toDate = (timestamp: number): Date => {
    return new Date(timestamp * 1000);
}

export const timestampToDay = (timestamp: number): string => {
    const date = toDate(timestamp);
    return toDay(date);
}

export const toDay = (date: Date) => {
    return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

}

export const toNumber = (value: bigint): number => {
    return ethers.toNumber(value);
};